import { render, staticRenderFns } from "./TextParser.vue?vue&type=template&id=8ebd9278"
import script from "./TextParser.vue?vue&type=script&lang=js"
export * from "./TextParser.vue?vue&type=script&lang=js"
import style0 from "./TextParser.vue?vue&type=style&index=0&id=8ebd9278&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports